/**
 * Created by Jonah Kim on 6/20/16.
 */
(function () {
    'use strict';

    // @ngInject
    function OnboardingOverviewControllerCtor($scope, $injector, $timeout, $window,
                                              Constants, AnalyticsService, UiPersistenceService, EventService, AppStates, ModalService, UserService, OnboardingService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'OnboardingOverviewController';
        this.$timeout = $timeout;
        this.$window = $window;
        this.UiPersistenceService = UiPersistenceService;
        this.EventService = EventService;
        this.AppStates = AppStates;
        this.ModalService = ModalService;
        this.UserService = UserService;
        this.OnboardingService = OnboardingService;
        this.AnalyticsService = AnalyticsService;

        this.states = Constants.OnboardingOverviewStates;

        this.onboardingProgressBarVisible = OnboardingService.showOnboardingBar();
        
        this.initUiPersistenceHash();
        this.initOnboardingStates();
        this.initCardCallbackMethods();
        AnalyticsService.trackPageView(this, 'OnboardingOverviewView');

        // TODO: This. has gone some refactoring but never tested since this screen was disabled
        // TODO: so if this screen is being used again the new persistency that is being done through the
        // TODO: Onboarding service now should be checked
        this.OnboardingService.on('onboardingOverviewTaskAccomplished', function hanldeOnboardingOverviewChagned(tasksHash) {
            this.UiPersistenceHash = tasksHash;
            this.initOnboardingStates();
        }.bind(this));

        $scope.$on("$destroy", function() {
            this.UiPersistenceService.off(null, null, this);
        }.bind(this));
    }

    Controllers.OnboardingOverviewController = Class(Controllers.BaseController, {
        constructor: OnboardingOverviewControllerCtor,

        initUiPersistenceHash: function initUiPersistenceHash(){
            this.UiPersistenceHash = this.OnboardingService.getOnboardingOverviewTaskAccomplished();

            if (this.OnboardingService.isStepComplete(this.OnboardingService.OnboardingSteps.createEvent)) {
                this.OnboardingService.markOnboardingOverviewTasksComplete('newLeadClicked');
            }
        },

        initOnboardingStates: function initOnboardingStates() {
            var uiHash = this.UiPersistenceHash;

            if (!uiHash){
                return;
            }
            this.createEventState = uiHash.newLeadClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.customizeAccountState = uiHash.customizeLinkClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.bringInExistingLeadState = uiHash.bringInExistingClientClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.clientSideState = uiHash.clientSideClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.webinarState = uiHash.webinarClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.proposalHelpClicked = uiHash.proposalHelpClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
            this.introClipState = uiHash.watchIntroVideoLinkClicked ? this.states.COMPLETE : this.states.INCOMPLETE;
        },

        initCardCallbackMethods: function initCardCallbackMethods(){
            var self = this;

            this.createEventClickHandler = function (){
                self.goToState(self.AppStates.root_core_navigation_pipeline);

                // Give the user some time to take the transition before popping up the modal.
                self.$timeout(function(){
                    self.EventService.createEventCommand();
                }, 1000);
            };

            this.customizeAccountClickHandler = function (){
                self.OnboardingService.markOnboardingOverviewTasksComplete('customizeLinkClicked');
                self.$window.open('https://intercom.help/honeybook-5891e2a409ff/getting-started/customizing-your-honeybook-account','_blank');
            };

            this.bringInExistingLeadClickHandler = function () {
                self.OnboardingService.markOnboardingOverviewTasksComplete('bringInExistingClientClicked');
                self.$window.open('https://intercom.help/honeybook-5891e2a409ff/getting-started/adding-existing-clients-and-files-from-another-system-into-honeybook', '_blank');
            };

            this.clientSideClickHandler = function() {

                if (self.requestInProgress) {
                    return;
                }

                self.requestInProgress = true;
                self.UserService.createExampleProposal().finally(function() {
                    self.requestInProgress = false;
                    self.OnboardingService.markOnboardingOverviewTasksComplete('clientSideClicked');
                });
            };

            this.introClipClickHandler = function () {
                self.OnboardingService.markOnboardingOverviewTasksComplete('watchIntroVideoLinkClicked');
                self.ModalService.openWelcomeVideoModal('Onboarding Overview');
            };

            this.webinarClickHandler = function() {
                self.OnboardingService.markOnboardingOverviewTasksComplete('webinarClicked');
                self.$window.open('https://www.honeybook.com/product-education', '_blank');
            };

            this.proposalHelpClickedkHandler = function() {
                self.OnboardingService.markOnboardingOverviewTasksComplete('proposalHelpClicked');
                self.$window.open('https://intercom.help/honeybook-5891e2a409ff/brochures-proposals-invoices/creating-and-sending-a-proposal', '_blank');
            };
        }
    });
}());

